'use client'

import {
  Group as Users,
  Wallet,
  Calculator,
  Education as GraduationCap,
  Cloud,
  MachineLearning as Brain,
  type CarbonIconType as LucideIcon,
} from '@carbon/icons-react'

import { productsData } from '@/app/products/[slug]/products'

/* The product record, on the same terms as the sibling products' data.ts:
   the name and slug come from products.ts so nothing here can drift from the
   source of truth. */
export const UDC = productsData.udc

/* UDC-specific data. Everything presentational now lives in the shared
   products/page-kit, which the HRMS page uses too; it is re-exported here so
   the UDC section files keep importing from one place. */
export {
  EASE,
  HAIRLINE,
  PANEL,
  PANEL_RESTING,
  PANEL_ACTIVE,
  useReveal,
  Eyebrow,
  SectionHead,
  QuietLink,
  restoreDashes,
} from '@/components/page-kit'

/* ─── The spine ───────────────────────────────────────────────────────────
   Six modules, always the same six, always in this order. The list is the
   page's structural device: it is the hero's index rail, the datastore bus,
   the attribution column of the spec sheet and the closing strip — one object
   seen from four angles, rather than four unrelated card grids. */
export const MODULES: {
  key: string
  name: string
  line: string
  icon: LucideIcon
}[] = [
  { key: 'hrms', name: 'HRMS', line: 'Faculty & staff lifecycle', icon: Users },
  {
    key: 'payroll',
    name: 'Payroll',
    line: 'Salary, PF, ESI & TDS',
    icon: Wallet,
  },
  {
    key: 'accounts',
    name: 'Accounts',
    line: 'Fees, ledgers & audit',
    icon: Calculator,
  },
  {
    key: 'lms',
    name: 'LMS',
    line: 'Courses, exams & outcomes',
    icon: GraduationCap,
  },
  {
    key: 'cloud',
    name: 'Cloud',
    line: 'Hosting, backup & uptime',
    icon: Cloud,
  },
  { key: 'ai', name: 'AI Engine', line: 'Insight & automation', icon: Brain },
]
